'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { AIReviewSummaryDS } from '@src/components/blocks/ai-review-summary-ds'
import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { AIReviewSummary } from '@src/quince-components/src/atoms/reviews/aiReviewSummary/AIReviewSummary'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import type { ReviewsSummaryWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// ---------------- REVIEWS_SUMMARY (AI summary block) ----------------
function ReviewsSummaryWidgetComponent(props: PLTypedWidgetProps<ReviewsSummaryWidgetData>) {
  const data = props.data.reviewsSummaryData
  if (!data?.text) return null

  if (shouldUseDesignSystem()) {
    return <AIReviewSummaryDS summary={data.text} heading={data.heading} hasReviewGalleryPhotos />
  }

  // The component renders its own "summarized by AI" sub-line (i18n); proto subText is informational.
  return <AIReviewSummary summary={data.text} heading={data.heading.toUpperCase()} hasReviewGalleryPhotos />
}

export const ReviewsSummaryWidget: PLTypedWidgetInterface<ReviewsSummaryWidgetData, WidgetType.REVIEWS_SUMMARY> = {
  id: WidgetType.REVIEWS_SUMMARY,
  errorBoundary: PLBaseErrorBoundary,
  render: ReviewsSummaryWidgetComponent,
}
